import Axios, { type AxiosRequestConfig } from "axios";
import qs from "qs";

export const client = Axios.create({
  adapter: "fetch",
  baseURL: import.meta.env.VITE_API_URL,
  paramsSerializer: (params) => qs.stringify(params, { indices: false, skipNulls: true }),
});

export const customClient = async <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> => {
  const response = await client({
    ...config,
    ...options,
  });

  return response.data;
};

export type BodyType<BodyData> = BodyData;
